import React from 'react';
import { SimpleForm, TextInput, FileInput, FileField, required } from 'react-admin';

function LayerForm(props) {
  return (
    <SimpleForm {...props}>
      <TextInput
        source="name"
        label="Nombre de la capa"
        validate={required('Debe ingresar un nombre')}
      />
      <FileInput
        source="files"
        multiple
        accept=".shp,.shx,.dbf,.prj,.cpg"
        label="Archivos del shapefile (.shp .shx .dbf .prj)"
        validate={required('Debe adjuntar los archivos del shapefile')}
      >
        <FileField source="src" title="title" />
      </FileInput>
    </SimpleForm>
  );
}

export default LayerForm;
